// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
import TimelineItem from "examples/Timeline/TimelineItem";

function OrdersOverview() {
  return (
    <Card className="h-100">
      <SoftBox pt={3} px={3}>
        <SoftTypography variant="h6" fontWeight="medium">
          PPF Templates Overview
        </SoftTypography>
        <SoftBox mt={1} mb={2}>
          <SoftTypography variant="button" color="text" fontWeight="regular">
            <SoftTypography display="inline" variant="body2" verticalAlign="middle">
              <Icon sx={{ fontWeight: "bold", color: ({ palette: { success } }) => success.main }}>
                arrow_upward
              </Icon>
            </SoftTypography>
            &nbsp;
            <SoftTypography variant="button" color="text" fontWeight="medium">
              15%
            </SoftTypography>{" "}
            more templates created this month
          </SoftTypography>
        </SoftBox>
      </SoftBox>
      <SoftBox p={2}>
        <TimelineItem
          color="success"
          icon="design_services"
          title="New PPF Template for Tesla Model 3"
          dateTime="22 DEC 7:20 PM"
        />
        <TimelineItem
          color="error"
          icon="inventory"
          title="Template revision requested for BMW X5"
          dateTime="21 DEC 11 PM"
        />
        <TimelineItem
          color="info"
          icon="build"
          title="Final approval for Ford F-150 template"
          dateTime="21 DEC 9:34 PM"
        />
        <TimelineItem
          color="warning"
          icon="edit"
          title="Design changes for Audi A8 PPF template"
          dateTime="20 DEC 2:20 AM"
        />
        <TimelineItem
          color="primary"
          icon="auto_awesome"
          title="New PPF template started for Mercedes S-Class"
          dateTime="18 DEC 4:54 AM"
        />
        <TimelineItem
          color="dark"
          icon="check_circle"
          title="Template completed for Toyota Prius 2023"
          dateTime="17 DEC"
        />
      </SoftBox>
    </Card>
  );
}

export default OrdersOverview;
